{
	"title": "Gestão de parceiros",
	"description": "Listagem e cadastro de clientes e fornecedores.",
	"pixKeyCopiedSuccess": "Chave PIX copiada com sucesso!",
	"pixKeyCopyError": "Erro ao copiar chave PIX",
	"name": "Nome / Nome fantasia",
	"customerName": "Nome",
	"namePlaceholder": "Digite o Nome Fantasia/Nome abreviado",
	"customerNamePlaceholder": "Digite o nome",
	"legalName": "Razão social",
	"legalNamePlaceholder": "Digite Razão social/Nome completo",
	"cpfOrCnpj": "CPF/CNPJ",
	"cpfOrCnpjPlaceholder": "Digite o CPF/CNPJ",
	"inscricaoEstadual": "Inscrição Estadual",
	"inscricaoEstadualPlaceholder": "Digite a inscrição estadual",
	"cep": "CEP",
	"cepPlaceholder": "Digite o CEP",
	"state": "Estado",
	"statePlaceholder": "Digite o estado",
	"city": "Cidade",
	"cityPlaceholder": "Digite a cidade",
	"street": "Endereço",
	"streetPlaceholder": "Digite o endereço",
	"streetNumber": "Número",
	"streetNumberPlaceholder": "Digite o número",
	"complemento": "Complemento",
	"complementoPlaceholder": "Digite o complemento",
	"neighborhood": "Bairro",
	"neighborhoodPlaceholder": "Digite o bairro",
	"bank": "Banco",
	"bankPlaceholder": "Digite o banco",
	"agency": "Agência",
	"agencyPlaceholder": "0000",
	"account": "Conta",
	"accountPlaceholder": "Digite a conta",
	"ownerName": "Nome do proprietário",
	"ownerNamePlaceholder": "Digite o nome do proprietário",
	"bankcpfOrCnpj": "CPF/CNPJ",
	"bankcpfOrCnpjPlaceholder": "Digite o CPF/CNPJ",
	"phone": "Telefone",
	"cellPhone": "Telefone celular",
	"email": "E-mail",
	"placeholderPhone": "(00) 0000-0000",
	"placeholderCellPhone": "(00) 0 0000-0000",
	"placeholderEmail": "examplo@email.com",
	"validateField": "Campo obrigatório",
	"wishToAdd": "Deseja criá-lo?",
	"popConfirm": "Você deseja mesmo apagar este item?",
	"notInformed": "Não informado",
	"address": "Endereço",
	"actions": "Ações",
	"type": "Tipo",
	"addNewRegister": "Cadastrar parceiro",
	"editRegister": "Editar parceiro",
	"generalData": "Dados Gerais",
	"bankData": "Dados bancários",
	"bankAccount": "Conta bancária",
	"searchPlaceholder": "Buscar por cliente, fornecedor, colaborador",
	"infoMessage": "O tipo de cadastro tem a finalidade de parametrizar os documentos financeiros utilizados por um cliente, um fornecedor ou ambos.",
	"registerTypes": {
		"client": "Cliente",
		"supplier": "Fornecedor",
		"customerAndSupplier": "Cliente e Fornecedor",
		"employee": "Colaborador"
	},
	"allPartners": "Todos os parceiros",
	"selectRegistrationType": "Tipo de parceiro",
	"modalWarningCancel": {
		"title": "Descartar alterações"
	},
	"confirmCancelRegistration": {
		"title": "Cancelar cadastro",
		"message": "Você está criando um cadastro de parceiros. Tem certeza que deseja cancelar?",
		"confirmText": "Continuar cadastro",
		"cancelText": "Cancelar"
	},
	"invalidAgency": "Agência inválida",
	"invalidAccount": "Conta inválida",
	"invalidZipCode": "CEP inválido",
	"invalidEmail": "E-mail inválido",
	"supplierDetails": "Detalhes do fornecedor",
	"customerDetails": "Detalhes do cliente",
	"employeeDetails": "Detalhes do colaborador",
	"customerAndSupplierDetails": "Detalhes do cliente e fornecedor",
	"viewDetails": "Ver detalhes",
	"pixKeyType": "Tipo de Chave PIX",
	"pixKeyTypePlaceholder": "Selecione o tipo",
	"pixKey": "Chave PIX",
	"pixKeyPlaceholder": "Digite a chave PIX",
	"pixKeyTypes": {
		"cpf": "CPF",
		"cnpj": "CNPJ",
		"email": "E-mail",
		"phone": "Telefone",
		"evp": "Chave Aleatória"
	},
	"pixKeyPlaceholders": {
		"cpf": "000.000.000-00",
		"cnpj": "00.000.000/0000-00",
		"email": "exemplo@email.com",
		"phone": "(00) 00000-0000",
		"evp": "Chave aleatória (UUID)"
	},
	"errors": {
		"unknown": "Erro desconhecido",
		"validationErrors": "Erros de validação:",
		"clearFieldError": "Limpar erro do campo",
		"cpfInvalid": "CPF inválido",
		"cnpjInvalid": "CNPJ inválido",
		"cpfMustHaveDigits": "CPF deve ter 11 dígitos",
		"cnpjMustHaveDigits": "CNPJ deve ter 14 dígitos",
		"emailInvalid": "E-mail inválido",
		"phoneMustHaveDigits": "Telefone deve ter 10 ou 11 dígitos",
		"randomKeyInvalidChars": "A chave PIX aleatória deve conter apenas números, letras e hífens",
		"randomKeyInvalidLength": "A chave PIX aleatória deve ter o formato correto com 32 caracteres",
		"randomKeyInvalidFormat": "Chave PIX aleatória inválida. Verifique se copiou corretamente do seu banco"
	},
	"fieldNames": {
		"id": "ID",
		"name": "Nome",
		"legalName": "Razão Social",
		"inscricaoEstadual": "Inscrição Estadual",
		"cpfOrCnpj": "CPF/CNPJ",
		"street": "Rua",
		"streetNumber": "Número",
		"complemento": "Complemento",
		"cep": "CEP",
		"state": "Estado",
		"city": "Cidade",
		"neighborhood": "Bairro",
		"bank": "Banco",
		"agency": "Agência",
		"account": "Conta",
		"bankcpfOrCnpj": "CPF/CNPJ",
		"ownerName": "Nome do Titular",
		"phone": "Telefone",
		"email": "Email",
		"cellPhone": "Celular",
		"registerType": "Tipo de Registro",
		"pixKeyType": "Tipo de Chave PIX",
		"pixKey": "Chave PIX"
	},
	"messages": {
		"pixKeyCopiedSuccess": "Chave PIX copiada com sucesso!",
		"pixKeyCopyError": "Erro ao copiar chave PIX"
	},
	"labels": {
		"pixKeyTypeUppercase": "TIPO DE CHAVE PIX",
		"pixKeyUppercase": "CHAVE PIX",
		"cpfCnpjUppercase": "CPF/CNPJ",
		"copyPixKey": "Copiar chave Pix"
	},
	"form": {
		"contactAndAddressSubtitle": "Informações de contato e endereço",
		"saving": "Salvando...",
		"maxAttemptsReached": "Máximo de tentativas atingido ({current}/{max})",
		"waitCooldown": "Aguarde {seconds}s",
		"reset": "Resetar",
		"submissionBlockedTooltip": "Submissão bloqueada - Tentativas: {current}/{max}",
		"cooldownTooltip": "Cooldown: {seconds}s"
	}
}
